import { Typography } from 'gu-ui-kit'
import RegistrationForm from 'modules/Forms/Auth/Registration'
import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { Redirect } from 'react-router'
import { ROUTES } from 'constants/routes'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { Nav } from 'layouts/AuthLayout/subcomponents'
import { SET_AUTH } from 'modules/Auth/types'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'

const Registration = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const refresh_token = localStorage.getItem('refresh_token')
  const [registrationSucceededTo, setRegistrationSucceededTo] = useState('')
  const pathGen = useGeneratePathI18n()
  const breakpoint = useBreakpoint()
  useEffect(
    () => !!refresh_token && dispatch({ type: SET_AUTH, payload: true }),
    [],
  )

  if (refresh_token) {
    return <Redirect to={pathGen(ROUTES.SERVICES)} />
  }

  return (
    <>
      <Helmet defer={false}>
        <title>{t('auth::registration.title')}</title>
      </Helmet>
      <Nav
        className={!breakpoint.fb ? 'margin-bottom-32' : 'margin-bottom-40'}
      />
      {registrationSucceededTo ? (
        <>
          <Typography
            component={'h1'}
            className={'margin-bottom-16'}
            variant={'Body-Accent-40'}
            color={'Label-Fifth'}
          >
            {t('auth::registration.title', { context: 'succeeded' })}
          </Typography>
          <Typography
            variant={'Body-15'}
            color={'Label-Fifth'}
            component={'p'}
            className={'margin-bottom-8'}
            dangerouslySetInnerHTML={{
              __html: t('auth::registration.description', {
                context: 'succeeded',
                email: registrationSucceededTo,
              }),
            }}
          />
          <Typography
            variant={'Body-15'}
            component={'p'}
            color={'Label-Fifth'}
            dangerouslySetInnerHTML={{
              __html: t('auth::registration.spam_warning', {
                noreply_email: `no-reply@${process.env.REACT_APP_DOMAIN}`,
              }),
            }}
          />
        </>
      ) : (
        <RegistrationForm onSuccess={setRegistrationSucceededTo} />
      )}
    </>
  )
}

export default Registration
